// Sportmann — galerie + selector variante pagina de produs
// Vanilla JS, fara dependinte, scoped la un singur formular per pagina de produs.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pdp-root]').forEach(initProduct);
  });

  function initProduct(root) {
    const variants = JSON.parse(root.querySelector('[data-pdp-variants]').textContent);
    const moneyFormat = root.getAttribute('data-pdp-money-format') || '{{amount}}';
    const mainImage = root.querySelector('[data-pdp-main-image]');
    const thumbs = root.querySelectorAll('[data-pdp-thumb]');
    const optionButtons = root.querySelectorAll('[data-pdp-option-value]');
    const variantIdInput = root.querySelector('[data-pdp-variant-id]');
    const priceNow = root.querySelector('[data-pdp-price-now]');
    const priceOld = root.querySelector('[data-pdp-price-old]');
    const addBtn = root.querySelector('[data-pdp-add-btn]');
    const addBtnLabel = addBtn ? addBtn.querySelector('[data-pdp-add-label]') : null;

    // Galerie: click pe thumbnail schimba imaginea principala
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
        const fullSrc = thumb.getAttribute('data-pdp-thumb-full');
        if (mainImage && fullSrc) mainImage.src = fullSrc;
      });
    });

    function currentSelection() {
      const selected = {};
      root.querySelectorAll('[data-pdp-option-value].active').forEach((btn) => {
        selected[btn.getAttribute('data-pdp-option-position')] = btn.getAttribute('data-pdp-option-value');
      });
      return selected;
    }

    function findMatchingVariant() {
      const selected = currentSelection();
      return variants.find((v) =>
        Object.keys(selected).every((pos) => v.options[Number(pos) - 1] === selected[pos])
      );
    }

    // Formatare compatibila cu shop.money_format (acelasi format ca filtrul Liquid `| money`)
    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      const withDecimalComma = amount.replace('.', ',');
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDecimalComma);
    }

    function updateForSelection() {
      const variant = findMatchingVariant();
      if (!variant) {
        if (addBtn) addBtn.setAttribute('disabled', 'disabled');
        if (addBtnLabel) addBtnLabel.textContent = 'Indisponibil';
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceNow) priceNow.textContent = formatMoney(variant.price);
      if (priceOld) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceOld.textContent = formatMoney(variant.compare_at_price);
          priceOld.style.display = '';
        } else {
          priceOld.style.display = 'none';
        }
      }

      if (variant.available) {
        if (addBtn) addBtn.removeAttribute('disabled');
        if (addBtnLabel) addBtnLabel.textContent = 'Adaugă în coș — ' + formatMoney(variant.price);
      } else {
        if (addBtn) addBtn.setAttribute('disabled', 'disabled');
        if (addBtnLabel) addBtnLabel.textContent = 'Stoc epuizat';
      }
    }

    optionButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const position = btn.getAttribute('data-pdp-option-position');
        root.querySelectorAll('[data-pdp-option-value][data-pdp-option-position="' + position + '"]').forEach((b) =>
          b.classList.remove('active')
        );
        btn.classList.add('active');
        updateForSelection();
      });
    });

    const qtyInput = root.querySelector('[data-pdp-qty-input]');
    root.querySelectorAll('[data-pdp-qty-minus]').forEach((btn) =>
      btn.addEventListener('click', () => {
        if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      })
    );
    root.querySelectorAll('[data-pdp-qty-plus]').forEach((btn) =>
      btn.addEventListener('click', () => {
        if (qtyInput) qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
      })
    );

    updateForSelection();
  }
})();
